import React from 'react';
import { SidebarMenuItem } from '../../molecules/SidebarMenuItem';
import styled from '@emotion/styled';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faWindowRestore, faCar, faCog, faMap } from '@fortawesome/free-solid-svg-icons';

export type MenuSelection =
    'Clock' |
    'Dashboard' |
    'Drive' |
    'Cockpit' |
    'RTC' |
    'Setting';

const MenuFrame = styled.div({
    backgroundColor: '#2A2D33',
    width: '210px',
    minHeight: '100%',
    height: 'fit-content',
});

type ItemProps = {
    name: MenuSelection;
    caption?: string;
    icon: IconDefinition;
    selectedItem: MenuSelection;
    onSelect: (result: MenuSelection) => void;
}

function Item(props: ItemProps) {
    const { name, caption, icon, selectedItem, onSelect } = props;
    return <SidebarMenuItem name={caption ?? name} icon={icon} active={selectedItem === name} onClick={() => onSelect(name)} />;
}

export type SidebarMenuProps = {
    selectedItem: MenuSelection;
    onSelect: (result: MenuSelection) => void;
}

export function SidebarMenu(props: SidebarMenuProps) {
    return (
        <MenuFrame>
            <Item {...props} name='Dashboard' icon={faWindowRestore} />
            <Item {...props} name='Drive' icon={faCar} caption='Grid Mode' />
            <Item {...props} name='Cockpit' icon={faMap} caption='Full Screen Mode' />
            <Item {...props} name='Setting' icon={faCog} caption='Settings' />
        </MenuFrame>
    );
}
